import React, { useEffect, useState } from "react";
import { Button, Card, Confirm, Dimmer, Form, Grid, Header, Image, Loader, Segment } from "semantic-ui-react";
import { useHistory } from "react-router";
import { IRecipientModelSnapshotIn, Recipient } from "../../Models/Recipient";
import { observer } from "mobx-react-lite";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import recipientPhoto from "../../Images/Temporary/recipientPhoto.jpg";
import { formType as formTypeEnum, ddlOptions } from "../Enums/FieldEnums";
import styles from './Questionnaire.style.module.css';
import { useAgeReadyContext } from "../../AgeReadyContext/AgeReadyContext";
interface IRecipientFormProps {
  isLoading: boolean;
  cancelButtonLabel: string;
  formType: string;
  selectedRecipient: any;
  onSaveClick: (savedRecipient: IRecipientModelSnapshotIn) => Promise<void>;
  onCancelClick: () => void;
}

const RecipientForm: React.FC<IRecipientFormProps> = (
  props: IRecipientFormProps
) => {
  const { onSaveClick, onCancelClick, cancelButtonLabel, isLoading, formType, selectedRecipient } = props;
  const history = useHistory();
  const [recipient, setNewRecipient] = useState(Recipient.create());
  const [showSaveLoading, setShowSaveLoading] = useState(false);

  const [openConfirm, setOpenConfirm] = useState<boolean>();
  const [onConfirmLoading, setOnConfirmLoading] = useState<boolean>(false);
  const [onCancelLoading, setOnCancelLoading] = useState<boolean>(false);
  const [file] = useState();
  const [imgFile, setImgFile] = useState<string | undefined>(recipientPhoto);
  const { promiseInProgress } = usePromiseTracker();
  const { partnerStore } = useAgeReadyContext();

  // eslint-disable-next-line
  useEffect(() => { createRecipient(); }, []);

  const mapRecipientFormFields = (objToUpdate: any, objWithValues: any) => {
    objToUpdate.setFirstName(objWithValues.firstName);
    objToUpdate.setLastName(objWithValues.lastName);
    objToUpdate.setGender(objWithValues.gender);
    objToUpdate.setRelationship(objWithValues.relationship);
    objToUpdate.setZipcode(objWithValues.zipCode);
    objToUpdate.setBirthday(objWithValues.birthday);
    objToUpdate.setNotes(objWithValues.notes);
    objToUpdate.setImgUrl(objWithValues.imgUrl);
  }
  const getLogoByPartnerId = (partnerId: string | undefined | null): string | undefined => {
    if (!partnerId) {
      return undefined;
    }
    return partnerStore.logosByPartnerId.get(partnerId);
  }
  const createRecipient = () => {
    if(selectedRecipient?.id && formType === formTypeEnum.EDIT) {
      const url = getLogoByPartnerId(selectedRecipient?.imgUrl);
      setImgFile(url);
      mapRecipientFormFields(recipient, selectedRecipient);
    }
  }
  const toBase64Async = (file: File) =>
    new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => resolve(fileReader.result);
      fileReader.onerror = error => reject(error);
    })
    const onUpload = async (e: any) => {
      const selectedFile = e.target.files[0];
      if (!selectedFile) {
        setImgFile(undefined);
        recipient.setImgUrl(null);
        return; 
      }
      setImgFile(URL.createObjectURL(selectedFile));
      const encodedLogoString = await trackPromise(toBase64Async(selectedFile));
      
      if (!!encodedLogoString) {
        recipient.setImgUrl(recipient.id);
        await trackPromise(partnerStore.setLogo(encodedLogoString as string, recipient.id));
      }
    }

  const saveClickHandler = async () => {
    if(selectedRecipient?.id && formType === formTypeEnum.EDIT) {
      mapRecipientFormFields(selectedRecipient, recipient);
      setShowSaveLoading(true)
      await onSaveClick(selectedRecipient); 
      setShowSaveLoading(false)
      
    } else {
      setOpenConfirm(true);
    }
  };

  const resetForm = () => {
    setNewRecipient(Recipient.create());
  };

  const shouldBeDisabled = () => {
    return (
      recipient.firstName.trim() === "" ||
      recipient.lastName.trim() === "" ||
      recipient.gender.trim() === "" ||
      recipient.birthday.trim() === "" ||
      recipient.zipCode.trim() === ""
    );
  };

  const onConfirm = async () => {
    try {
      setOnConfirmLoading(true);
      setShowSaveLoading(true)
      await onSaveClick(recipient); //add in a string param for Patching
      setShowSaveLoading(false)
      resetForm();
      setOpenConfirm(false);
    } catch (e) {
      throw e;
    } finally {
      setOnConfirmLoading(false);
    }
  };

  const onConfirmCancel = async () => {
    try {
      setOnCancelLoading(true);
      setShowSaveLoading(true)
      await onSaveClick(recipient); //add in a string param for Patching
      setShowSaveLoading(false)
      setOpenConfirm(false);
      history.push("/home");
    } catch (e) {
      throw e;
    } finally {
      setOnCancelLoading(false);
    }
  };

  const confirmContent = () => (
    <>
      <Card.Header>
        <div style={{ display: "inline", textAlign: "center" }}>
          <Header style={{ paddingTop: 40, paddingBottom: 20 }}>
            Would you like to add another Recipient?
          </Header>
        </div>
      </Card.Header>
    </>
  );

  return (
    <Segment basic style={{ borderRadius: 40, padding: 0 }}>
      <Dimmer active={isLoading} style={{ padding: 0 }}>
        <Loader data-testid="saveLoader" />
      </Dimmer>
      <Card style={{ width: "100%", borderRadius: 40, padding: 15, marginTop: 0, marginBottom: 30, background: '#fff' }}>
        <Card.Header style={{ paddingTop: 20, textAlign: "center" }}>
          <Header as="h1" style={{ paddingBottom: 40, textAlign: "center" }}>{formType} Recipient</Header>
        </Card.Header>
        {formType === formTypeEnum.ADD && (
        <Confirm
          open={openConfirm}
          confirmButton={{ content: "Yes", loading: onConfirmLoading }}
          cancelButton={{ content: "No", loading: onCancelLoading }}
          onConfirm={onConfirm}
          onCancel={onConfirmCancel}
          content={confirmContent}
        />)}
        <Form id={styles['recipient-form']}>
          <Grid columns="equal" stackable>
            <Grid.Row >
              <Grid.Column stretched width={5}>
                <Image
                  src={imgFile||recipientPhoto}
                  id={styles['recepient-pic']}
                  style={{
                    borderRadius: "70px",
                    maxHeight: '75%',
                    flexGrow:'initial'
                  }} />
                <br/>
                <Dimmer active={promiseInProgress} style={{ padding: 0 }}>
                  <Loader data-testid="saveLoader" />
                </Dimmer>
                <Form.Input
                  className={styles['fix-input-mobile']}
                  input={{ "data-testid": "image-upload", }}
                  value={file}
                  type="file"
                  onChange={onUpload}
                  label="Upload Photo (optional): "
                />
              </Grid.Column>
              <Grid.Column stretched> 
                <Form.Group widths='equal' >
                  <Form.Input
                    required
                    input={{ "data-testid": "saveRecipient", }}
                    value={recipient.firstName}
                    onChange={(e) => { recipient.setFirstName(e.target.value); }}
                    type="text"
                    label="First Name"
                    error={!recipient.firstName}
                  />
                  <Form.Input
                    required
                    input={{ "data-testid": "saveRecipient", }}
                    value={recipient.lastName}
                    onChange={(e) => { recipient.setLastName(e.target.value); }}
                    type="text"
                    label="Last Name"
                    error={!recipient.lastName}
                  />
                </Form.Group>
                <Form.Group widths='equal'>
                  <Form.Select
                    fluid
                    required
                    label='Gender'
                    value={recipient.gender || ''}
                    onChange={(e, { value }) =>
                      recipient.setGender(value as string)
                    }
                    error={!recipient.gender}
                    options={[
                      {
                        key: 'male',
                        value: ddlOptions.MALE,
                        text: ddlOptions.MALE
                      },
                      {
                        key: 'female',
                        value: ddlOptions.FEMALE,
                        text: ddlOptions.FEMALE
                      },
                      {
                        key: 'prefer_not_to_say',
                        value: ddlOptions.PREFER_NOT_TO_SAY,
                        text: ddlOptions.PREFER_NOT_TO_SAY
                      }
                    ]}
                  />
                  <Form.Input
                    fluid
                    input={{ "data-testid": "recipientZipcode", }}
                    type="text"
                    value={recipient.zipCode}
                    onChange={(e) => { recipient.setZipcode(e.target.value); }}
                    label="Zipcode" 
                  />
                </Form.Group>
                <Form.Group widths='equal' >
                  <Form.Input
                    fluid
                    required
                    input={{ "data-testid": "recipientBirthday", }}
                    value={recipient.birthday}
                    type="date"
                    onChange={(e) => { recipient.setBirthday(e.target.value); }}
                    label="Birthday"
                    error={!recipient.birthday}
                  />
                 <Form.Select
                    fluid
                    required
                    label="Relationship to You"
                    value={recipient.relationship || ''}
                    onChange={(e, { value }) => recipient.setRelationship(value as string)}
                    error={!recipient.relationship}
                    options={[
                        { key: 'parent', value: ddlOptions.PARENT, text: ddlOptions.PARENT },
                        { key: 'grandparent', value: ddlOptions.GRANDPARENT, text: ddlOptions.GRANDPARENT },
                        { key: 'aunt_uncle', value: ddlOptions.AUNT_UNCLE, text: ddlOptions.AUNT_UNCLE },
                        { key: 'friend', value: ddlOptions.FRIEND, text: ddlOptions.FRIEND },
                        { key: 'self', value: ddlOptions.SELF, text: ddlOptions.SELF },
                        { key: 'spouse', value: ddlOptions.SPOUSE, text: ddlOptions.SPOUSE },
                        { key: 'other', value: ddlOptions.OTHER, text: ddlOptions.OTHER },
                        { key: 'prefer_not_to_say', value: ddlOptions.PREFER_NOT_TO_SAY, text: ddlOptions.PREFER_NOT_TO_SAY }
                    ]}
                  />
                </Form.Group>
                <Form.TextArea
                    fluid="true"
                  value={recipient.notes ?? ""}
                  onChange={(e) => { recipient.setNotes(e.target.value); }}
                  label="Notes"
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row> 
              <Grid.Column textAlign="right" id={styles['recepient-cta']}>
                <Button onClick={onCancelClick} content={cancelButtonLabel} className={styles['cta-on-mobile']}  />
                <Button primary content="Save" onClick={() => { saveClickHandler() }} loading={showSaveLoading} disabled={shouldBeDisabled()} className={styles['cta-on-mobile']}   />
              </Grid.Column>
            </Grid.Row>
          </Grid> 
        </Form>
      </Card>
    </Segment>
  );
};

export default observer(RecipientForm);
